import { Component, OnInit, Input, AfterViewInit, ElementRef, ViewChild } from "@angular/core";
import { Canvas, Circle, Path, Polygon, Rect, Triangle } from "fabric";

@Component({
  standalone: true,
  selector: "app-canvas-shape",
  templateUrl: "./canvas-shape.component.html",
  styleUrls: ["./canvas-shape.component.scss"],
})
export class CanvasShapeComponent implements OnInit, AfterViewInit {
  @ViewChild("canvas") canvasRef!: ElementRef;

  @Input()
  shape: any;

  @Input()
  location: string = "";

  canvas: any;

  path: any;
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.canvas = new Canvas(this.canvasRef.nativeElement, {
      hoverCursor: "hand",
      selection: false,
      defaultCursor: "hand",
    });
    // this.canvas.setWidth("60");
    // this.canvas.setHeight("60");

    switch (this.shape.type.toLowerCase()) {
      case "triangle":
        this.handleTriangle();
        break;
      case "rect":
        this.handleRect();
        break;
      case "circle":
        this.handleCircle();
        break;
      case "poly":
        this.handlePolygon();
        break;
      default:
        this.handleRegularShape();
        break;
    }
    this.canvas.add(this.path);
    this.canvas.renderAll();
    this.canvas.centerObject(this.path);

    // this.canvas.add(this.path);
    // this.path.center();
    // this.path.setCoords();
    // this.canvas.renderAll();
  }

  handleTriangle() {
    this.path = new Triangle({
      left: 25,
      top: 25,
      width: 50,
      height: 50,
      fill: "#000000",
      stroke: "",
      strokeWidth: 0,
      originX: "center",
      selectable: false,
      lockMovementY: true,
      lockMovementX: true,
      hasBorders: false,
      hasControls: false,
      hoverCursor: "hand",
      objectCaching: false,
    });
    return;
  }

  handleRect() {
    this.path = new Rect({
      left: 25,
      top: 25,
      fill: "#000000",
      stroke: "",
      strokeWidth: 0,
      width: 25,
      height: 25,
      selectable: false,
      lockMovementY: true,
      lockMovementX: true,
      hasBorders: false,
      hasControls: false,
      hoverCursor: "hand",
      objectCaching: false,
    });
    return;
  }

  handleCircle() {
    this.path = new Circle({
      fill: "#000000",
      scaleY: 0.5,
      scaleX: 0.5,
      originX: "center",
      originY: "center",
      left: 0,
      top: 0,
      stroke: "",
      strokeWidth: 0,
      radius: 25,
      selectable: false,
      lockMovementY: true,
      lockMovementX: true,
      hasBorders: false,
      hasControls: false,
      hoverCursor: "hand",
      objectCaching: false,
    });
    return;
  }

  handlePolygon() {
    if (this.shape.name.toLowerCase() === "trapezoid 1") {
      this.path = new Polygon(
        [
          { x: -100, y: -50 },
          { x: 100, y: -50 },
          { x: 150, y: 50 },
          { x: -150, y: 50 },
        ],
        {
          left: 25,
          top: 25,
          scaleX: 0.15,
          scaleY: 0.15,
          fill: "#000000",
          stroke: "",
          strokeWidth: 0,
          selectable: false,
          lockMovementY: true,
          lockMovementX: true,
          hasBorders: false,
          hasControls: false,
          hoverCursor: "hand",
          objectCaching: false,
        }
      );
      return;
    } else if (this.shape.name.toLowerCase() === "emerald 1") {
      this.path = new Polygon(
        [
          { x: 0, y: -125 },
          { x: 108, y: -62.5 },
          { x: 108, y: 62.5 },
          { x: 0, y: 125 },
          { x: -108, y: 62.5 },
          { x: -108, y: -62.5 },
        ],
        {
          left: 25,
          top: 25,
          scaleX: 0.15,
          scaleY: 0.15,
          fill: "#000000",
          stroke: "",
          strokeWidth: 0,
          selectable: false,
          lockMovementY: true,
          lockMovementX: true,
          hasBorders: false,
          hasControls: false,
          hoverCursor: "hand",
          objectCaching: false,
        }
      );
      return;
    } else if (this.shape.name.toLowerCase() === "star 1") {
      this.path = new Polygon(
        [
          { x: 350, y: 75 },
          { x: 380, y: 160 },
          { x: 470, y: 160 },
          { x: 400, y: 215 },
          { x: 423, y: 301 },
          { x: 350, y: 250 },
          { x: 277, y: 301 },
          { x: 303, y: 215 },
          { x: 231, y: 161 },
          { x: 321, y: 161 },
        ],
        {
          left: 25,
          top: 25,
          scaleX: 0.15,
          scaleY: 0.15,
          fill: "#000000",
          stroke: "",
          strokeWidth: 0,
          selectable: false,
          lockMovementY: true,
          lockMovementX: true,
          hasBorders: false,
          hasControls: false,
          hoverCursor: "hand",
          objectCaching: false,
        }
      );
      return;
    } else {
      this.path = new Polygon(
        [
          { x: 0, y: 0 },
          { x: 100, y: 50 },
          { x: 200, y: 0 },
          { x: 150, y: 100 },
          { x: 200, y: 200 },
          { x: 100, y: 150 },
          { x: 0, y: 200 },
          { x: 50, y: 100 },
          { x: 0, y: 0 },
        ],
        {
          left: 25,
          top: 25,
          scaleX: 0.15,
          scaleY: 0.15,
          fill: "#000000",
          stroke: "",
          strokeWidth: 0,
          selectable: false,
          lockMovementY: true,
          lockMovementX: true,
          hasBorders: false,
          hasControls: false,
          hoverCursor: "hand",
          objectCaching: false,
        }
      );
      return;
    }
  }

  handleRegularShape() {
    this.path = new Path(this.shape.content);
    const scale = 40 / this.path.width;
    this.path.set({
      left: 25,
      top: 25,
      scaleX: scale,
      scaleY: scale,
      fill: "#000000",
      stroke: null,
      strokeWidth: 0,
      objectCaching: false,
      selectable: false,
      lockMovementY: true,
      lockMovementX: true,
      hasBorders: false,
      hasControls: false,
      hoverCursor: "hand",
    });
    return;
  }

  createPathObject(path: { width: number }, type: any) {
    const scale = 100 / path.width;
    this.path.set({
      left: 25,
      top: 25,
      scaleX: 0.5,
      scaleY: 0.5,
      fill: "#000000",
      stroke: null,
      strokeWidth: 0,
      userData: {
        type,
        shape: true,
      },
      objectCaching: false,
    });

    return path;
  }
}
